import { PerformanceAnalyticsDispatcher } from '../../performance/PerformanceAnalyticsDispatcher';
import { AdobeAnalyticsDispatcher } from './AdobeAnalyticsDispatcher';
import { AnalyticsLogger } from './AnalyticsLogger';
import { BookingFormAnalyticsDispatcher } from './BookingFormAnalyticsDispatcher';
import { PracticeAdminAnalyticsDispatcher } from './PracticeAdminAnalyticsDispatcher';
import { SentryTagDispatcher } from './SentryTagDispatcher';

/** The standard set of analytics event dispatchers.
 * When an analytics event is tracked, each of these dispatchers will observe it and
 * possibly dispatch it to their service.
 *
 * @requires an <AnalyticsProvider /> ancestor
 */
export const AnalyticsDispatchers = () => (
  <>
    <AnalyticsLogger />
    <AdobeAnalyticsDispatcher />
    <PracticeAdminAnalyticsDispatcher />
    <BookingFormAnalyticsDispatcher />
    <PerformanceAnalyticsDispatcher />
    <SentryTagDispatcher />
  </>
);
